import accountTransactions from "./accountTransactions";
import app from "./app";
import bankAccounts from "./bankAccounts";
import countries from "./countries";
import customer from "./customer";
import customerSupport from "./customerSupport";
import documents from "./documents";
import error from "./error";
import flyt from "./flyt";
import flyttPkb from "./flyttPkb";
import fondsskole from "./fondsskole";
import fundSwitch from "./fundSwitch";
import holdingsHistory from "./holdingsHistory";
import init from "./init";
import investmentPrograms from "./investmentPrograms";
import kartlegging from "./kartlegging";
import log from "./log";
import newPolicy from "./newPolicy";
import norskPensjon from "./norskPensjon";
import policies from "./policies";
import prices from "./prices";
import prognosis from "./prognosis";
import samtykke from "./samtykke";
import session from "./session";
import sl from "./sl";
import uiState from "./uiState";
import utbetalingsoversikt from "./utbetalingsoversikt";

export const NOOP = "NOOP";

// This suddenly started breaking our build so fix it first and figure out why later
// export const noop = () => ({ result: NOOP });

export function noop() {
	return { result: NOOP };
}

export default {
	...accountTransactions,
	...app,
	...bankAccounts,
	...countries,
	...customer,
	...customerSupport,
	...documents,
	...error,
	...fondsskole,
	...fundSwitch,
	...holdingsHistory,
	...investmentPrograms,
	...log,
	...newPolicy,
	...norskPensjon,
	...policies,
	...prognosis,
	...samtykke,
	...session,
	...sl,
	...flyttPkb,
	...uiState,
	...utbetalingsoversikt,
	...prices,
	...kartlegging,
	...flyt,
	...init,
};
